import React from 'react';

import Frame from '../../Containers/Frame/Frame';

function NotFound(props) {
  return <Frame><h1>404</h1></Frame>
}

export default NotFound;